/* eslint-disable react-dom/no-dangerously-set-innerhtml */

import type { ComponentPropsWithoutRef, ElementType } from 'react'

type RichTextElementProps<T extends ElementType> = {
  as?: T
  html?: string | null
} & Omit<
  ComponentPropsWithoutRef<T>,
  'as' | 'children' | 'dangerouslySetInnerHTML'
>

export const RichTextElement = <T extends ElementType = 'div'>(
  props: RichTextElementProps<T>,
) => {
  const { as, html, ...rest } = props
  const Component = (as || 'div') as ElementType

  return (
    <Component {...rest} dangerouslySetInnerHTML={{ __html: html || '' }} />
  )
}
